import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductModel, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import { EOLProducts, productModelExtended, PromotionState } from "@WhiteCap/Store/Data/PromotionState";
import { Draft } from "immer";

const initialState: PromotionState = {
    promotionId: "",
    isLoading: false,
    products: [],
    eolProducts: null,
};

const reducer = {
    "Custom/Promotion/BeginLoadProducts": (draft: Draft<PromotionState>) => {
        draft.isLoading = true;
    },
    "Custom/Promotion/BeginPromotionId": (draft: Draft<PromotionState>, action: { promotionId: string }) => {
        draft.promotionId = action.promotionId;
    },
    "Custom/Promotion/CompletedLoadProducts": (
        draft: Draft<PromotionState>,
        action: {
            products: productModelExtended[];
        },
    ) => {
        draft.products = action.products;
    },
    "Custom/Promotion/EOLLoadProducts": (
        draft: Draft<PromotionState>,
        action: {
            eolProducts: EOLProducts;
        },
    ) => {
        draft.eolProducts = action.eolProducts;
    },

    "Custom/Promotion/BeginEndedProducts": (draft: Draft<PromotionState>) => {
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
